<template lang="pug">
.v-flex-collection.flex-collection.main-page-section(v-if="data")
	.container
		v-main-section-header.main-page-section__header(
			v-if="data.header"
			:data="data.header"
			@navigation="setNavigation")
		.flex-collection__grid
			template(v-for="(item, index) in data.items" :key="index" )
				.flex-collection__item
					.presentation-card
						a.presentation-card__link(:href="item?.link?.href")
						template(v-if="isSm")
							img.presentation-card__image(v-if="item?.image?.srcSm"
								:src="item.image.srcSm"
								:alt="item.image.alt")
						template(v-else)
							img.presentation-card__image(v-if="item?.image?.src"
								:src="item.image.src"
								:alt="item.image.alt")
						.presentation-card__tags(v-for="(tag, ind) in item.tags" :key="ind" )
							.presentation-card__tags-item
								.card-tag
									.card-tag__bg
									.card-tag__text {{tag.text}}

</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
	export default {

		mixins: [
			sourceMixin,
			isMobMixin
		],

		data() {
			return {
				data: null
			}
		},

		methods: {
			dataSet(data) {
				this.data = data;
			}
		}
	}

</script>